import { render, staticRenderFns } from "./LifeLInkDashboard.vue?vue&type=template&id=2e606c78"
import script from "./LifeLInkDashboard.vue?vue&type=script&lang=js"
export * from "./LifeLInkDashboard.vue?vue&type=script&lang=js"
import style0 from "./LifeLInkDashboard.vue?vue&type=style&index=0&id=2e606c78&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports